import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Home } from "lucide-react";
import { useSettings } from "../hooks/useSettings";

const Navbar = () => {
  const { data: settings } = useSettings();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const links = [
    { to: "/", label: "Home" },
    { to: "/properties", label: "Properties" },
    { to: "/projects", label: "Projects" },
    { to: "/localities", label: "Areas" },
    { to: "/sell", label: "Sell" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/75 border-b border-stone-200" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="navbar-logo">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-brand text-white">
            <Home size={20} />
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-lg font-semibold text-stone-900">
              {settings?.firm_name || "Satyam Real Estate"}
            </span>
            <span className="block text-[10px] uppercase tracking-[0.25em] text-stone-400">Jaipur, India</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.label} to={l.to}
              className="text-sm font-medium text-stone-600 hover:text-brand transition-colors"
              data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
          <button onClick={() => navigate("/properties")}
            className="rounded-full bg-stone-900 text-white text-sm font-medium px-5 py-2.5 hover:bg-brand transition-colors"
            data-testid="nav-explore-btn">
            Explore Listings
          </button>
        </nav>

        <button className="md:hidden text-stone-800" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-stone-200 bg-white px-5 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)}
              className="text-base font-medium text-stone-700" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
